import {
  orgID,
  websiteID,
  traceID,
  sessionID,
  apiDomain,
} from "../../settings";

type LogParams = {
  severity: number;
};

const traceIDQueryParameter = "tid";
const btTagVersionQueryParameter = "cv";
const sessionIDQueryParameter = "sid";

export async function log(
  event: string,
  meta: Record<string, object> = {},
  params: LogParams = { severity: 1 }
) {
  const query = {
    [traceIDQueryParameter]: traceID,
    [btTagVersionQueryParameter]: window.__bt_tag_d?.version || "",
    [sessionIDQueryParameter]: sessionID,
    upapi: String(true),
  };

  const body = {
    event,
    meta,
    orgID,
    severity: params.severity,
    websiteID: websiteID,
  };

  const search = new URLSearchParams(query);
  const url = new URL(`https://${apiDomain}/log?` + search);

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
